import { render } from "./FavouriteLawyers.vue?vue&type=template&id=9a156f7a"
import script from "./FavouriteLawyers.vue?vue&type=script&lang=js"
export * from "./FavouriteLawyers.vue?vue&type=script&lang=js"

import "./FavouriteLawyers.vue?vue&type=style&index=0&id=9a156f7a&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__